export { default } from "./RecordDetailDrawer";
